module.exports = __webpack_public_path__ + "static/img/logo.e9b1f8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.png
// module id = bPD/
// module chunks = 1